// @flow
import React from 'react';
import './RadioButton.scss';

// Components
import Checkbox from 'components/atoms/Checkbox';

const ns = 'radio-button';

type Props = {
  label: string,
  id: string,
  isSelected: boolean,
  onClick: () => void,
  onKeyUp: () => void,
  ariaLabel: string,
  name: string
};

const RadioButton = (props: Props) => {
  const { label, isSelected, id } = props;
  return (
    <div className={ns + (isSelected ? ` ${ns}--selected` : '')}>
      <Checkbox inputType="radio" {...props} />
      <label className={`${ns}__label`} htmlFor={id}>
        {label}
      </label>
    </div>
  );
};

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/atoms/RadioButton/RadioButton.js